// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as Services from "./services/index";
import Clipboard from 'clipboard';
Vue.config.productionTip = false
Vue.prototype.Clipboard = Clipboard

Vue.prototype.$services = {
  ...Services,
};
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = '大淘客实时热销榜2.0内测报名'
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js